import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import {Link} from "react-router-dom";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import ApiConfig from "../api/ApiConfig";
import {deleteWithAuthCall, getWithAuthCallWithErrorResponse} from "../api/ApiServices";
import swal from "sweetalert";
import Table from "react-bootstrap/Table";
import Loading from "../sharedComponents/Loaders/Loading";
import {PaginationCustomer} from "./PaginationCustomer";

const Users = () => {
  const { sidebar } = useContext(AppContext);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [numPages, setNumPages] = useState(1);
  const changePage = (page) => {
    if (page > 0 && page <= numPages) {
      setCurrentPage(page);
    }
  };

  // Search func()ty state
  const [searchInput, setSearchInput] = useState("");

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setSelectedUserID(id);
  };

  const [deleteShow, setDeleteShow] = useState(false);
  const handleDeleteClose = () => setDeleteShow(false);
  const handleDeleteShow = (id) => {
    setDeleteShow(true);
    setSelectedUserID(id);
  };

  const [viewShow, setViewShow] = useState(false);
  const handleViewClose = () => setViewShow(false);
  const handleViewShow = (id) => {
    setViewShow(true);
    setSelectedUserID(id);
  };

  const [userList, setUserList] = useState([]);
  const [selectedUserID, setSelectedUserID] = useState("");
  const [userDetails, setUserDetails] = useState({});
  const getUserList = (page = 1) => {
    getWithAuthCallWithErrorResponse(ApiConfig.USER_LIST + `?page=${page}&size=${perPage}`)
      .then((res) => {
        let data = res.json;
        if (data) {
          setUserList(data.userDetails || []);
          setPerPage(data.per_page || 15);
          setNumPages(data.num_pages || 1);
          setCurrentPage(data.current_page || 1);
        }
        console.log("FIONAL User DATA", data?.userDetails?.length);

        // setCount({ ...count, userCount: data?.userDetails?.length });
      }).catch((err) => {
        console.log(err);
      });
  };
  const getUserDetails = () => {
    getWithAuthCallWithErrorResponse(
      ApiConfig.VIEW_USER_DETAILS + selectedUserID
    )
      .then((res) => {
        // console.log(res);
        let data = res.json;
        if (data) {
          setUserDetails(data.userDetailView);
        }
      })

      .catch((err) => {
        console.log(err);
      });
  };

  const deleteUser = () => {
    deleteWithAuthCall(ApiConfig.DELETE_USER + selectedUserID)
      .then((res) => {
        // console.log(res);
        getUserList();
        handleDeleteClose();
        swal({
          text: res.message,
          icon: "success",
          timer: 2000,
          dangerMode: true,
        });
      })

      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getUserList();
    if (selectedUserID) {
      getUserDetails();
    }

    return () => { };
  }, [selectedUserID]);

  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">USERS</label>
        </div>
        <div className="add-btn"></div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>USER ID CARD VERIFICATION</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Full Name:</label>
            </div>
            <div className="col-md-9">
              <span>
                {userDetails?.fullName ? userDetails?.fullName : "NULL"}{" "}
              </span>
            </div>
          </div>
          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Email :</label>
            </div>
            <div className="col-md-9 ">
              <span>{userDetails?.email ? userDetails?.email : "NULL"} </span>
            </div>
          </div>

          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Date of Birth :</label>
            </div>
            <div className="col-md-9 ">
              <span>
                {userDetails?.dateOfBirth ? userDetails?.dateOfBirth : "NULL"}
              </span>
            </div>
          </div>
          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">ID Card :</label>
            </div>
            <div className="col-md-9 ">
              <span>{userDetails?.idCard ? userDetails?.idCard : "NULL"} </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="buttons-modal    ">
            <button className="me-2 " type="submit" onClick={handleClose}>
              Cancel
            </button>
            <button className=" " type="submit">
              Verify User
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={viewShow}
        onHide={handleViewClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>USER DETAILS</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Full Name:</label>
            </div>
            <div className="col-md-9 ">
              <span>
                {userDetails?.fullName ? userDetails?.fullName : "NULL"}{" "}
              </span>
            </div>
          </div>

          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Email :</label>
            </div>
            <div className="col-md-9 ">
              <span>{userDetails?.email ? userDetails?.email : "NULL"} </span>
            </div>
          </div>

          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Phone Number :</label>
            </div>
            <div className="col-md-9 ">
              <span>
                {userDetails?.phoneNumber ? userDetails?.phoneNumber : "NULL"}
              </span>
            </div>
          </div>
          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Date of Birth :</label>
            </div>
            <div className="col-md-9 ">
              <span>
                {userDetails?.dateOfBirth ? userDetails?.dateOfBirth : "NULL"}
              </span>
            </div>
          </div>
          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Verification Status :</label>
            </div>
            <div className="col-md-9 ">
              <span>
                {userDetails?.verificationStatus
                  ? userDetails?.verificationStatus
                  : "NULL"}
              </span>
            </div>
          </div>
          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">Address(es) :</label>
            </div>
            <div className="col-md-9 ">
              <span>
                {userDetails?.address ? userDetails?.address : "NULL"}
              </span>
            </div>
          </div>
          <div className="row user-detail">
            <div className="col-md-3 ">
              <label htmlFor="">ID Card :</label>
            </div>
            <div className="col-md-9 ">
              <span>{userDetails?.idCard ? userDetails?.idCard : "NULL"} </span>
            </div>
          </div>

          {/* <div className="table-user-details">
            <table>
              <thead>
                <tr className="table-heading">
                  <th colspan="7">ORDER</th>
                </tr>
                <tr className="item-heading">
                  <th>Sr No</th>
                  <th>Order Status</th>
                  <th>Address</th>
                  <th>City</th>
                  <th>Total Products</th>
                  <th>Price</th>
                  <th>Date & Time</th>
                </tr>
              </thead>
              <tbody>
           
                <tr>
                  <td>1</td>
                  <td>Order Placed</td>
                  <td>Lorem ipsum dolor sit er elit lamet, consecsxmb</td>
                  <td>Pune</td>
                  <td>0</td>
                  <td>Rs 10000.0</td>
                  <td>June 28 2022, 10:03 AM</td>
                </tr>
              </tbody>
            </table>
          </div> */}
        </Modal.Body>
      </Modal>

      <Modal
        show={deleteShow}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Do you want to delete?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 "
              type="submit"
              style={{ backgroundColor: "red" }}
              onClick={deleteUser}
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>

      <div className="table-wrapper">
        <div className="headerFlex">
          <div className="innerLabel">
            <label className="labelTxt">
              Total Records : {userList.length}
            </label>
          </div>
          <div className="searchFilter">
            <input
              type="text"
              className="form-control"
              placeholder="Search By Name ..."
              value={searchInput}
              onChange={handleSearchInputChange}
            />
          </div>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <Table striped hover className="display">
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Name</th>
                <th>Email</th>
                {/* <th>Phone Number</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {userList
                .filter((item) => {
                  return item.name
                    .toLowerCase()
                    .includes(searchInput.toLowerCase());
                })
                .map((user, index) => {
                  return (
                    <tr key={"user" + index}>
                      <td>{index + 1}</td>
                      <td>{user?.name}</td>
                      <td>{user?.email}</td>
                      {/* <td>{user?.phoneNumber ? user?.phoneNumber : "NULL"}</td> */}
                      {/* <td className="verify">
                        <Link
                          to="#"
                          className="icon"
                          onClick={() => {
                            handleShow(user.id);
                          }}
                        >
                          Verify
                        </Link>
                      </td> */}
                      <td className="action">
                        <Link
                          to="#"
                          className="icon"
                          onClick={() => {
                            handleViewShow(user.id);
                          }}
                        >
                          <img src={ic_eyes} alt="" />
                        </Link>

                        <Link
                          to="#"
                          className="icon"
                          onClick={() => {
                            handleDeleteShow(user.id);
                          }}
                        >
                          <img src={ic_delete} alt="" />
                        </Link>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        )}
        <div className="d-flex justify-content-end">
          {userList && userList.length > 0 ? (
              <PaginationCustomer
                  changePage={changePage}
                  pageCount={numPages}
                  currentPage={currentPage}/>
          ) : (
            <div>
              <h5 style={{ color: "red" }}> Records Not Found</h5>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default Users;
